import * as React from "react"
import { Menu as ReactMenu, MenuItem, useMenuState } from "@szhsin/react-menu"
import { Link } from "gatsby"
// import "@szhsin/react-menu/dist/index.css"
// import "@szhsin/react-menu/dist/transitions/slide.css"

export default function Menu({ links = [], title = "" } = {}) {
  // const ref = React.useRef(null)
  const [menuProps, toggleMenu] = useMenuState({ transition: true })
  return (
    <>
      <ReactMenu
        menuButton={
          <div
            // ref={ref}
            onPointerEnter={() => toggleMenu(true)}
            onClick={() => toggleMenu(true)}
            className="link"
            onKeyDown={e => {
              if (e.key === " " || e.key === "Enter" || e.key === "Spacebar") {
                toggleMenu(true)
              }
            }}
            // role="menu"
            // tabIndex={0}
          >
            {title}
          </div>
        }
      >
        {links.map(
          ({ name, link, outlined, inNewTab }) =>
            name &&
            (inNewTab ? (
              <a
                role="menuitem"
                key={link}
                className={outlined ? "link-highlight" : "link-menu-item"}
                href={link}
                target="_blank"
                rel="noreferrer"
              >
                <MenuItem>{name}</MenuItem>
              </a>
            ) : (
              <Link
                role="menuitem"
                key={link}
                className={outlined ? "link-highlight" : "link-menu-item"}
                to={link}
                {...(inNewTab ? { target: "_blank" } : undefined)}
              >
                <MenuItem>{name}</MenuItem>
              </Link>
            ))
        )}
        {/* <MenuItem>New File</MenuItem> */}
      </ReactMenu>
    </>
  )
}
